import React from "react";
import { Modal, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AppButton } from "../form";
import { useAppCustomStyles } from "../../assets/theme/custom/hooks";

const ErrorModal = ({ open, handleClose, message }: { open: boolean; handleClose: () => void; message: string }) => {
  const { t } = useTranslation();
  const custom = useAppCustomStyles();

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="error-modal-title"
      aria-describedby="error-modal-description"
    >
      <Box sx={custom.components.errorModal.modalBox}>
        <Typography id="error-modal-title" variant="h6" component="h2">
          {t("error.title")}
        </Typography>
        <Typography id="error-modal-description" sx={custom.components.errorModal.description}>
          {message}
        </Typography>
        <AppButton onClick={handleClose} sx={custom.components.errorModal.closeButton}>
          {t("common.close")}
        </AppButton>
      </Box>
    </Modal>
  );
};

export default ErrorModal;
